"use client";

import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { useEffect, useRef, useState } from "react";
export default function Hero() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    once: true,
    threshold: 0.1
  });
  const parallaxRef = useRef<HTMLDivElement>(null);
  const [parallaxOffset, setParallaxOffset] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      if (parallaxRef.current) {
        const rect = parallaxRef.current.getBoundingClientRect();
        const scrolled = window.scrollY;
        const offset = scrolled * 0.3;
        setParallaxOffset(offset);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section ref={parallaxRef} className="relative w-full min-h-[600px] flex items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 bg-cover bg-center transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)]" style={{
      backgroundImage: "url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1511866/img/hero_inspection_background.png)",
      transform: `translateY(${parallaxOffset}px)`
    }} />
      {}
      <div className="absolute inset-0 bg-dark-background/70" />
      {}
      <div ref={ref} className={`relative z-10 max-w-4xl mx-auto px-6 text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
        <h1 className="text-5xl md:text-6xl font-bold text-foreground mb-4">
          Professionele keuringen voor uw woning
        </h1>
        <h2 className="text-2xl md:text-3xl font-semibold text-foreground mb-8">
          EPC, asbest en elektriciteit – snel, betrouwbaar en betaalbaar
        </h2>

        <Link to="/PricingPage">
          <Button size="lg" className="bg-primary text-foreground-primary hover:bg-primary-hover hover:shadow-medium hover:scale-[1.04] active:bg-primary-active active:scale-100 transition-all duration-[120ms] ease-[var(--ease-spring)] px-8 py-4 text-lg font-semibold rounded-md">
            Keuring in 1 minuut aanvragen
          </Button>
        </Link>

        <p className="text-sm text-foreground mt-4">
          Of vraag een gratis schatting vastgoed
        </p>
      </div>
    </section>;
}